export function numeroFlexivel(value: unknown): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  let raw = String(value ?? '')
    .replace(/R\$\s*/gi, '')
    .replace(/\s+/g, '')
    .trim();
  if (!raw) return 0;

  const comma = raw.lastIndexOf(',');
  const dot = raw.lastIndexOf('.');
  if (comma >= 0 && dot >= 0) {
    raw = comma > dot ? raw.replace(/\./g, '').replace(',', '.') : raw.replace(/,/g, '');
  } else if (comma >= 0) {
    raw = raw.replace(',', '.');
  }

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}
